import React from 'react';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { useGlobalMenu } from '../../../../contexts/GlobalMenuStore';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { SkipLink } from '../../../../_lib/components/SkipLink';

export function GlobalSkipLinks() {
  const { t } = useSonTranslation('SkipLinks');
  const { availableSections } = useAppContext();
  const { toggleSearch, togglePAL } = useGlobalMenu();

  return (
    <div className="skip-links" role="region" aria-label={t('label')}>
      <SkipLink id={GlobalDocumentIds.mainContent}>{t('content')}</SkipLink>

      {availableSections.pageManagement && (
        <SkipLink id={GlobalDocumentIds.pageManagement}>{t('pageManagement')}</SkipLink>
      )}

      <SkipLink id={GlobalDocumentIds.instantSearch} onClick={() => toggleSearch()}>
        {t('search')}
      </SkipLink>

      <SkipLink id={GlobalDocumentIds.personal} onClick={() => togglePAL()}>
        {t('personalaccesslibrary')}
      </SkipLink>
    </div>
  );
}
